import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    IJackpotRoom,
    // IJackpotState,
    // IRoomState,
    // TJackpotRoom,
} from '@api/types/jackpot';
// import { LOW_ROOM_SLUG } from '@consts/jackpot';
import getReducersLayout from '@redux/utils/getReducersLayout';
// import {
//     resetWinnersInLobby,
//     storeGameHasFinished,
//     storeWinner,
// } from '@redux/actions/jackpot';

// const ROOM_INITIAL_STATE: IRoomState = {
//     gameHasFinished: false,
//     winner: undefined,
// };

const initialState: { rooms: IJackpotRoom[] } = {
    rooms: [],
};

const jackpotSlice = createSlice({
    name: 'jackpot',
    initialState,
    reducers: {
        ...getReducersLayout(initialState),
        setJackpotRooms: (
            state,
            action: PayloadAction<{ rooms: IJackpotRoom[] }>,
        ) => {
            state.rooms = action.payload.rooms;
        },
    },
});

export const { resetData, setData, setJackpotRooms } = jackpotSlice.actions;
export default jackpotSlice;
